import React from "react";

const CERInfosListItem = ({ children }) => {
  return <li className="d-flex align-items-center flex-row">{children}</li>;
};

export default CERInfosListItem;
